import BaseIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberBase.svg?react"
import BronzeIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberBrons.svg?react"
import GoldIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberGuld.svg?react"
import PlatinumIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberPlatina.svg?react"
import SilverIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberSilver.svg?react"
import MemberIcon from "@/assets/icons/membershipSnowflakes/SkiStarMemberWhite.svg?react"

const MemberLevelIcon: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  "0": MemberIcon,
  "10": BaseIcon,
  "20": BronzeIcon,
  "30": SilverIcon,
  "40": GoldIcon,
  "50": PlatinumIcon,
}

export default MemberLevelIcon
